<template>
<div>
  <div class="top-bar-background">
    <div class="tabs-nav-container">
      <div class="tabs-nav-column-container">
        <button class="tabs-nav-button-active" :disabled="isThreadActive" @click="isThreadActive = true; isProfileActive = false">🧵 My threads</button>
      </div>
    </div>
  </div>

  <div class="sub-header-container">
    <div class="sub-header-content">
      <div class="page-title-container">
        <div class="page-title">My profile</div>
        <div v-if="isProfileActive">
          <button class="secondary-button"  style="margin-right: 0px;" @click="logOut">Log out</button>
        </div>
      </div>
      <button @click="$router.push({ path: '/post-thread' })" class="primary-button" style="float: right; margin-right: 0px;">Submit Thread</button>
    </div>

    <div v-if="firebase.auth.currentUser.providerData[0].providerId === 'twitter.com'">
      <p style="opacity: 0.5;">{{firebase.auth.currentUser.providerData[0].displayName}}</p>
    </div>
    <div v-if="firebase.auth.currentUser.providerId === 'firebase'">
      <p style="opacity: 0.5;">{{firebase.auth.currentUser.email}}</p>
    </div>

  </div>

  
  <h1 style="text-align: center; padding-top: 20px; padding-bottom: 50%; color: var(--secondary-text-color);" v-if="threads.length === 0">You didn't submitted any thread yet. <br/> Click <router-link to="/post-thread">here</router-link> to create your first one. 🧵</h1>

  <div class="page-container">
    <div v-if="isThreadActive">
      <Tweet
        v-for="(c, i) in threads" 
        :key="`tweet-card-${i}`"

        :id="c.id"
        :title="c.title"
        :text="c.tweet.text"
        :createdAt="c.createdAt"
        :is-bot="c.isBot === true"
        :primary-tags="c.primaryTags"
        :secondary-tags="c.secondaryTags"

        :author-id="c.author.id_str"
        :profile-image-url="c.author.profile_image_url_https"
        :location="c.author.location"
        :followers-count="c.author.followers_count"
        :description="c.author.description"
        :screen-name="c.author.screen_name"
        :name="c.author.name"  
      />
      <div class="pagination-container">
        <button class="previous-page-button" v-if="hasPrevious" @click="previous('createdAt', threads[0])"><i class="fas fa-arrow-left previous-page-button-icon"></i>Previous</button>
        <button class="next-page-button" v-if="hasNext" @click="next('createdAt', threads[threads.length - 1])">Next<i class="fas fa-arrow-right next-page-button-icon"></i></button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import firebase from '@/firebase'
import Tweet from '@/components/Tweet'

export default {
  components: {
    Tweet,
  },

  data() {
    return {
      firebase,
      isProfileActive: true,
      isThreadActive: true,
      pageSize: 2,
      threads: [],
      currentPage: 1,
      size: 0,
      likedTags: [],
      ref: firebase.firestore.collection("threads2").where("userId", "==", firebase.auth.currentUser.uid)
    }
  },

  mounted() {
    this.ref
        .limit(this.pageSize)
        .get()
        .then((snapshot) => {
            this.size = snapshot.size
            snapshot.forEach(async (doc) => {
              const parsed = doc.data()
              parsed.id = doc.id
              this.threads.push(parsed)
            })
          })
          .catch(function(error) {
            console.error("Error getting documents: ", error)
          })
  },

  computed: {
    hasPrevious() {
      return this.currentPage != 1
    },

    hasNext() {
      return this.currentPage < this.pages
    },

    pages() {
      return Math.ceil(this.size / this.pageSize)
    }
  },

  methods: {
    logOut() {
      firebase.auth
      .signOut()
        .then(() => {
          this.$router.push({ path: '/' })
        })
        .catch((error) => {
          console.error(error)
          this.$router.push({ path: '/' })
        })
    },

    next(field, last) {
      this.threads = []
      this.ref
        .orderBy(field)
        .startAfter(last[field])
        .limit(this.pageSize)
        .get()
        .then((snapshot) => {
            snapshot.forEach(async (doc) => {
              this.currentPage++
              var parsed = await this.parse(doc)
              this.threads.push(parsed)
              window.twttr.widgets.load()
            })
          })
          .catch(function(error) {
            console.error("Error getting documents: ", error)
          })
    },

    previous(field, first) {
      this.threads = []
      this.ref
        .orderBy(field)
        .endBefore(first[field])
        .limitToLast(this.pageSize)
        .get()
        .then((snapshot) => {
            this.currentPage--
            snapshot.forEach(async (doc) => {
              var parsed = await this.parse(doc)
              this.threads.push(parsed)
            })
          })
          .catch(function(error) {
            console.error("Error getting documents: ", error)
          })
    },
  }
}
</script>

<style scoped>
.header-container{
  background-color: var(--global-header-color);
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: var(--global-background-color);
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 5;
}
.pagination-container{
  background-color: none;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0px auto 10px auto;
  height: 100px;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .tabs-nav-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem 0.1rem 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .pagination-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
  .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
}
</style>
